module.exports = __webpack_public_path__ + "media/images/plan-grid2@2x-7283425c7f69870f25ddcf0b5258e162.jpg";